import { Outlet } from 'react-router-dom';
import { BrandInjector } from '../stores/BrandContext';
import styles from './DashboardLayout.module.css';
import Sidebar from './Sidebar';

export default function DashboardLayout() {
  return (
    <BrandInjector>
      <div className={styles.container}>
        <Sidebar />
        <main className={styles.main}>
          <div className={styles.content}>
            <Outlet />
          </div>
        </main>
      </div>
    </BrandInjector>
  );
}
